import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

type CancellationOverlayContextValue = {
  isOpen: boolean;
  openCancellation: () => void;
  closeCancellation: () => void;
};

const CancellationOverlayContext = createContext<CancellationOverlayContextValue | null>(null);

export function CancellationOverlayProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openCancellation = useCallback(() => setIsOpen(true), []);
  const closeCancellation = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ isOpen, openCancellation, closeCancellation }),
    [isOpen, openCancellation, closeCancellation]
  );

  return (
    <CancellationOverlayContext.Provider value={value}>
      {children}
    </CancellationOverlayContext.Provider>
  );
}

export function useCancellationOverlay() {
  const ctx = useContext(CancellationOverlayContext);
  if (!ctx) throw new Error("useCancellationOverlay must be used within CancellationOverlayProvider");
  return ctx;
}
